import { render, staticRenderFns } from "./BrandingAreaSetting.vue?vue&type=template&id=312786db&scoped=true"
import script from "./BrandingAreaSetting.vue?vue&type=script&lang=js"
export * from "./BrandingAreaSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312786db",
  null
  
)

export default component.exports